export default __webpack_public_path__ + "static/brian-1dc90ca5855b085ed4b654943166f028.jpg";